import React, { useState, useEffect } from 'react'
import { Col, ControlLabel, Icon, Message, Panel, Radio, RadioGroup, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import InputForm from '../../components/forms/input/InputForm'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { SaveClosureIPFrom } from '../../redux/actions/closeOfProject'
import EditButton from '../../components/buttons/editButton/EditButton'
import { isEmpty } from 'lodash-es'

export default function PropertyArisingFromProjectWidget({ setConfirmIP = () => {}, showCommandButton, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [ipResult, setIpResult] = useState(props?.schema?.ipResult?.value || '1')
  const [isConfirmIP, setIsConfirmIP] = useState(props?.schema?.isConfirm || false)
  const [confirmSelected, setConfirmSelected] = useState(!isEmpty(props?.schema?.id))

  const projectId = sessionStorage.getItem('projectId')
  const rowStyle = { marginTop: 5 }

  const handleSave = async (req) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await SaveClosureIPFrom(projectId, req)
      if (response) {
        setFormSchema(response)
        setIpResult(response?.ipResult?.value || '1')
        setIsConfirmIP(response?.isConfirm || false)
        setConfirmIP(response?.isConfirm || false)
        setConfirmSelected(!isEmpty(response?.id))

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error ', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.Message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit => ', data)

    let req = {
      id: formSchema.Id || null,
      isConfirmIP: isConfirmIP,
      ipResult: data.ipResult,
      ipName: data.ipName,
    }

    handleSave(req)
  }

  return (
    <>
      {formSchema && (
        <>
          <Panel
            shaded
            collapsible
            defaultExpanded
            header={formSchema.header}
            bordered
            style={{ marginBottom: 20 }}
          >
            <Row style={{ marginLeft: 10, marginBottom: 20 }}>
              {formSchema.message && (
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Message
                    showIcon
                    type="warning"
                    description={
                      <div>
                        {/* <label>{formSchema.message}</label> */}
                        <div dangerouslySetInnerHTML={{ __html: formSchema.message }} />
                        {showCommandButton && confirmSelected ? (
                          <>
                            <label style={{ marginLeft: 20 }}>
                              {isConfirmIP ? (
                                <Icon icon={'check-circle'} size="lg" style={{ color: '#2da888' }}>
                                  ใช่
                                </Icon>
                              ) : (
                                <Icon icon={'close-circle'} size="lg" style={{ color: '#fb8a81' }}>
                                  {' '}
                                  ไม่ใช่
                                </Icon>
                              )}
                            </label>
                            <EditButton
                              style={{
                                marginLeft: 10,
                              }}
                              onClick={() => {
                                setConfirmSelected(false)
                                setIsConfirmIP(false)
                              }}
                              children="แก้ไข"
                            />
                          </>
                        ) : (
                          <>
                            {!formSchema.disabled && (
                              <>
                                <SaveButton
                                  style={{ marginLeft: 10 }}
                                  icon="check"
                                  onClick={() => {
                                    setConfirmSelected(true)
                                    setIsConfirmIP(true)
                                  }}
                                  children="ใช่"
                                />
                                <CancelButton
                                  style={{ marginLeft: 10 }}
                                  onClick={() => {
                                    setIsShowConfirm(true)
                                  }}
                                  children="ไม่ใช่"
                                />
                              </>
                            )}
                          </>
                        )}
                      </div>
                    }
                  />
                </Col>
              )}
            </Row>

            <Row style={{ marginLeft: 10 }}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <ControlLabel>
                  {requiredFiled(formSchema.ipResult.validators, formSchema.ipResult.label)}
                </ControlLabel>
                <ErrorMessage error={errors[`${formSchema.ipResult.name}`]} />
                <Controller
                  name={formSchema.ipResult.name}
                  control={control}
                  defaultValue={formSchema.ipResult.value || '1'}
                  rule={register(isValidators(formSchema.ipResult.validators))}
                  render={(props) => {
                    return (
                      <RadioGroup
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setIpResult(value)
                        }}
                        
                      >
                        {formSchema.ipResult.options.map((item) => (
                          <Radio key={item.value} value={item.value} disabled={!showCommandButton}>
                            {item.label}
                          </Radio>
                        ))}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>

              {(ipResult == '2' || ipResult == '3') && (
                <>
                  {formSchema.note && (
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Message
                        showIcon
                        type="info"
                        description={<p style={{ marginTop: 1 }}>{formSchema.note}</p>}
                        style={{ marginTop: 20 }}
                      />
                    </Col>
                  )}
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <InputForm
                      rows={3}
                      componentClass="textarea"
                      schema={formSchema.ipName}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={!showCommandButton}
                    />
                  </Col>
                </>
              )}
            </Row>

            {showCommandButton && 
            <Row style={rowStyle}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <hr />
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  {formSchema.buttonText}
                </SaveButton>
              </Col>
            </Row>}
          </Panel>

          <ConfirmWidget
            size="md"
            title={''}
            show={isShowConfirm}
            detail={
              <Message
                showIcon
                type="warning"
                description={
                  <p style={{ marginTop: 1 }}>
                    กรุณากรอกรายละเอียดงานวิจัยและนวัตกรรมให้ครบถ้วนก่อน
                  </p>
                }
              />
            }
            confirmBtn={'รับทราบ'}
            // cancleBtn="ปิด"
            onCancle={() => {
              setIsShowConfirm(false)
            }}
            onConfirm={() => {
              setConfirmSelected(true)
              setIsConfirmIP(false)
              setIsShowConfirm(false)
            }}
          />
        </>
      )}
    </>
  )
}
